import {
  BrowserRouter,
  Navigate,
  Outlet,
  Route,
  Routes,
} from "react-router-dom";
import { Provider } from "urql";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { AuthProvider } from "./contexts/AuthContext";
import {
  adminClient,
  candidatePublicClient,
  selfClient,
} from "./graphql/client";
import { EmployeeInterviewLayout } from "./layouts/EmployeeInterviewLayout";
import {
  AdminSummaryCheck,
  Dashboard,
  DashboardGoogleCallback,
  GoogleConnect,
  InterviewerDashboard,
  InterviewerLogin,
  InterviewerScripts,
  InterviewerSummaryCheck,
  Interviews,
  Login,
  Schedule,
  SponsorDetail,
  Sponsors,
  StakeholderInterviewDetail,
  TemplatePresets,
  TermDetailRoute,
  TermReport,
  Users,
} from "./pages";

function AdminGraphqlLayout() {
  return (
    <Provider value={adminClient}>
      <Outlet />
    </Provider>
  );
}

function SelfGraphqlLayout() {
  return (
    <Provider value={selfClient}>
      <Outlet />
    </Provider>
  );
}

function CandidatePublicGraphqlLayout() {
  return (
    <Provider value={candidatePublicClient}>
      <Outlet />
    </Provider>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* 公開ページ（認証不要） */}
          <Route path="/employee_interview/login" element={<Login />} />
          <Route
            path="/employee_interview/interviewer/login"
            element={<InterviewerLogin />}
          />
          <Route element={<CandidatePublicGraphqlLayout />}>
            <Route
              path="/employee_interview/schedule/:token"
              element={<Schedule />}
            />
          </Route>

          {/* 認証済みページ */}
          <Route element={<ProtectedRoute />}>
            <Route element={<AdminGraphqlLayout />}>
              {/* 共通ルート（認証済みユーザー全員がアクセス可能） */}
              <Route element={<EmployeeInterviewLayout />}>
                <Route
                  path="/employee_interview"
                  element={
                    <Navigate to="/employee_interview/dashboard" replace />
                  }
                />
                <Route
                  path="/employee_interview/dashboard"
                  element={<Dashboard />}
                />
                <Route
                  path="/employee_interview/terms/:termId"
                  element={<TermDetailRoute />}
                />
                <Route
                  path="/employee_interview/terms/:termId/report"
                  element={<TermReport />}
                />
                <Route element={<SelfGraphqlLayout />}>
                  <Route
                    path="/employee_interview/google-connect"
                    element={<GoogleConnect />}
                  />
                  <Route
                    path="/employee_interview/dashboard/google-callback"
                    element={<DashboardGoogleCallback />}
                  />
                </Route>
              </Route>

              {/* 管理者専用ルート */}
              <Route element={<EmployeeInterviewLayout requiredRole="admin" />}>
                <Route
                  path="/employee_interview/sponsors"
                  element={<Sponsors />}
                />
                <Route
                  path="/employee_interview/sponsors/:sponsorId"
                  element={<SponsorDetail />}
                />
                <Route path="/employee_interview/users" element={<Users />} />
                <Route
                  path="/employee_interview/interviews"
                  element={<Interviews />}
                />
                <Route
                  path="/employee_interview/template-presets"
                  element={<TemplatePresets />}
                />
                <Route
                  path="/employee_interview/stakeholder-interviews/:interviewId"
                  element={<StakeholderInterviewDetail />}
                />
                <Route
                  path="/employee_interview/summary-check/:interviewId"
                  element={<AdminSummaryCheck />}
                />
              </Route>
            </Route>

            {/* インタビュアー専用ルート */}
            <Route element={<SelfGraphqlLayout />}>
              <Route
                element={<EmployeeInterviewLayout requiredRole="interviewer" />}
              >
                <Route
                  path="/employee_interview/interviewer/dashboard"
                  element={<InterviewerDashboard />}
                />
                <Route
                  path="/employee_interview/interviewer/scripts/:interviewId"
                  element={<InterviewerScripts />}
                />
                <Route
                  path="/employee_interview/interviewer/summary-check/:interviewId"
                  element={<InterviewerSummaryCheck />}
                />
              </Route>
            </Route>
          </Route>

          <Route
            path="*"
            element={<Navigate to="/employee_interview/login" replace />}
          />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
